import { availabilityConstants } from '../actions/constants/availabilityConstants';

interface AvailabilityMap {
  [date: string]: { MORNING: boolean; EVENING: boolean };
}

const initialState = {
  availabilityMap: {} as AvailabilityMap,
  loading: false,
  error: null as any,
  dirtyState: false,
  lastFetched: {} as AvailabilityMap,
  lastFetchedRaw: [] as any[],
  localReasons: {} as Record<string,string>,
};

const availabilityReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case availabilityConstants.fetchAvailabilityRequest:
      return { 
        ...state, 
        loading: true, 
        error: null 
      };
    case availabilityConstants.fetchAvailabilitySuccess:
      return { 
        ...state, loading: false, 
        availabilityMap: action.payload?.availability || {}, 
        lastFetched: action.payload?.availability || {}, 
        lastFetchedRaw: action.payload?.raw || [], 
        dirtyState: false 
      };
    case availabilityConstants.fetchAvailabilityFailure:
      return { 
        ...state, 
        loading: false, 
        error: action.payload 
      };
    case availabilityConstants.setLocalAvailability:
      return { 
        ...state, 
        availabilityMap: { ...action.payload }, 
        dirtyState: true 
      };
    case availabilityConstants.toggleSession: {
      const { date, session } = action.payload;
      const map = { ...state.availabilityMap };
      if (!map[date]) map[date] = { MORNING: true, EVENING: true };
      map[date][session] = !map[date][session];
      return { 
        ...state, 
        availabilityMap: map, 
        dirtyState: true 
      };
    }
    case availabilityConstants.setLocalReason: {
      const { date, session, reason } = action.payload;
      const key = `${date}|${session}`;
      const localReasons = { ...state.localReasons };
      if (reason) localReasons[key] = reason; else delete localReasons[key];
      return { 
        ...state, 
        localReasons, 
        dirtyState: true 
      };
    }
    case availabilityConstants.resetLocalAvailability:
      return { 
        ...state, 
        availabilityMap: { ...state.lastFetched }, 
        localReasons: {}, 
        dirtyState: false 
      };

    case availabilityConstants.updateAvailabilityRequest:
      return { 
        ...state, 
        loading: true, 
        error: null 
      };
    case availabilityConstants.updateAvailabilitySuccess:
      return { 
        ...state, 
        loading: false, 
        dirtyState: false, 
        lastFetched: { ...state.availabilityMap } 
      };
    case availabilityConstants.updateAvailabilityFailure:
      return { 
        ...state, 
        loading: false, 
        error: action.payload 
      };

    default:
      return state;
  }
};

export default availabilityReducer;
